module.exports = __webpack_public_path__ + "assets/img/online_qq.423af3cb.svg";